import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import { BiMenu } from 'react-icons/bi'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

class Changepassword extends React.Component {
  constructor(props) {
    const isMobile = window.innerWidth <= 768
    super(props)
    this.state = {
      query: '',
      password: '',
      newPassword: '',
      retypePassword: '',
      response: '',
      error: '',
      successError: '',
      errorDisplay: 'none',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)
    let { customerid, customername } = ''

    if (localStorage.getItem('customername') !== null) {
      customername = localStorage.getItem('customername') + ' - Customer'
      customerid = localStorage.getItem('customerid')
    } else if (localStorage.getItem('businessname') !== null) {
      customername = localStorage.getItem('businessname') + ' - Organiser'
      customerid = localStorage.getItem('businessid')
    } else if (localStorage.getItem('partnername') !== null) {
      customername = localStorage.getItem('partnername') + ' - Affiliate'
      customerid = localStorage.getItem('partnerid')
    }

    document.title = customername + ' - Password'
  }

  handlePass1 = (event) => {
    this.setState({
      newPassword: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePass2 = (event) => {
    this.setState({
      retypePassword: event.target.value,
      errorDisplay: 'none',
    })
  }

  handlePass3 = (event) => {
    this.setState({
      password: event.target.value,
      errorDisplay: 'none',
    })
  }

  update = () => {
    let { accountid, customername } = ''

    if (localStorage.getItem('customername') !== null) {
      customername = localStorage.getItem('customername')
      accountid = localStorage.getItem('customerid')
    } else if (localStorage.getItem('businessname') !== null) {
      customername = localStorage.getItem('businessname')
      accountid = localStorage.getItem('businessid')
    } else if (localStorage.getItem('partnername') !== null) {
      customername = localStorage.getItem('partnername')
      accountid = localStorage.getItem('partnerid')
    }

    const accounttype = localStorage.getItem('accounttype')

    const password = this.state.password.trim()
    const newPassword = this.state.newPassword
    const retypePassword = this.state.retypePassword

    if (newPassword.length < 8) {
      this.setState({
        error: 'Password should be at least 8 characters long',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (newPassword !== retypePassword) {
      this.setState({
        error: 'Make sure both your passwords match',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else if (password === '') {
      this.setState({
        error: 'To update your password, please enter your current one.',
        errorDisplay: 'block',
        successError: 'error-login',
      })
    } else {
      const baseURL = `${API_URL}/apps/kscanner/webservices.php`
      const data = new FormData()
      data.append('newpassword', newPassword)
      data.append('currentpass', password)
      data.append('accountid', accountid)
      data.append('subquery', accounttype)
      data.append('query', 'CHANGEPASSWORD')

      Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'success-login',
            })
          } else {
            // alert(accountype);
            this.setState({
              error: response.data.message,
              errorDisplay: 'block',
              successError: 'error-login',
            })
          }

          setTimeout(() => {
            this.setState({
              errorDisplay: 'none',
            })
          }, 5000)
        })
        .catch(function (error) {
          alert(error)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = localStorage.getItem('partnername')
          dashboard = 'in'
        }
      } else {
        accountname = localStorage.getItem('businessname')
        dashboard = 'dashboard'
      }
    } else {
      accountname = localStorage.getItem('customername')
      dashboard = 'customerdashboard'
    }
    const customername = accountname
    const credentials = this.props.location.state.credentials

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}
        <div
          className="container"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? 'auto' : 'auto',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-7 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-12 pl-0">
                      <button onClick={() => this.props.history.goBack()} className="link-btn">
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer pl-0 pr-0 mb-5">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title pl-0 pr-0">CHANGE PASSWORD</label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body pb-3">
                  New password
                  <br />
                  <input type="password" onChange={this.handlePass1} className="edit-input" />
                  <br /> <br />
                  Confirm password
                  <br />
                  <input type="password" onChange={this.handlePass2} className="edit-input" />
                  <br /> <br />
                  Current password (required to confirm changes)
                  <br />
                  <input type="password" onChange={this.handlePass3} className="edit-input" />
                </div>
                <div className="col-12 text-right mt-3">
                  <label className="back-arrow mb-0">
                    <div className="save-btn" onClick={() => this.update()}>
                      Save
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={this.state.successError}
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Changepassword
